// tanstack
import { createFileRoute } from '@tanstack/react-router';

// components
import WaterBasic from '@/features/dashboards/layouts/WaterBasic';

export const Route = createFileRoute(
  '/$accountId/_user/dashboards/water-basic',
)({
  component: WaterBasic,
  staticData: { crumb: 'dashboards-water-basic:title' },
});
